import "./index.css"
import {isLocalDev} from "./src/Utils/misc";

const checkVersion = await fetch("/api/version", {cache: 'no-store'});
const version = await checkVersion.text();

let loadedVersion = window.localStorage.getItem("version");

if(!loadedVersion){
    loadedVersion = version
    window.localStorage.setItem("version", version);
}

if(version !== loadedVersion) {
    console.log("Version mismatch, received : ", version);

    if ('serviceWorker' in navigator) {
        const registrations = await navigator.serviceWorker.getRegistrations();
        for (let i = 0; i < registrations.length; i++)
            await registrations[i].unregister();
    }

    window.localStorage.removeItem("version");

    //@ts-ignore
    window.location.reload(true);
}else{
    console.log("Version : " + loadedVersion);

    if ('serviceWorker' in navigator && !isLocalDev()) {
        await navigator.serviceWorker.register('/service-worker.js');
    }

    await (await import('./src/Initializer')).default(loadedVersion);
}


export { };
